import React from 'react';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Help.css";


export default function About() {
  const [content, setContent] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  

  useEffect(() => {
    fetch("/data/Services.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);


  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
        
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  
  if (!content) return <Loading />;  

  return (
    <>
      <NavbarLog />
      <div className="help-page">
        <div className="help-grid">
          <h1>{content.h1}</h1>
          <p>{content.p1}</p>
          {content.Services.map((sec, idx) => (
            <div className="help-section" key={idx}>
              <h2>{sec.T}</h2>
              <p>{sec.D}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}